import { render } from "./PaymentFailPage.vue?vue&type=template&id=1ab21978&scoped=true"
import script from "./PaymentFailPage.vue?vue&type=script&lang=js"
export * from "./PaymentFailPage.vue?vue&type=script&lang=js"

import "./PaymentFailPage.vue?vue&type=style&index=0&id=1ab21978&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab21978"]])

export default __exports__